import React from 'react';
import refreshPopImage from '../assets/images/refresh-pop.png';
import hintOkBtnImage from '../assets/images/06quiz-hintOk-btn.png';

interface FirebaseErrorPopupProps {
  isVisible: boolean;
  onClose: () => void;
  message?: string;
}

const FirebaseErrorPopup: React.FC<FirebaseErrorPopupProps> = ({ 
  isVisible, 
  onClose, 
  message = "데이터를 불러오는 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요." 
}) => {
  if (!isVisible) return null;

  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.9)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
        fontFamily: 'MapoDPP, sans-serif'
      }}
      onClick={onClose}
    >
      <div 
        style={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          maxWidth: '90%',
          maxHeight: '90%'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* refresh-pop.png 이미지 */}
        <img 
          src={refreshPopImage} 
          alt="데이터 로딩 오류"
          style={{
            maxWidth: '100%',
            height: 'auto',
            display: 'block'
          }}
        />
        
        {/* 에러 메시지 (선택사항) */}
        {message && (
          <div 
            style={{
              marginTop: '20px',
              padding: '15px 20px',
              backgroundColor: 'rgba(255, 255, 255, 0.9)',
              borderRadius: '10px',
              textAlign: 'center',
              fontSize: '16px',
              color: '#333',
              maxWidth: '300px',
              lineHeight: '1.4',
              fontFamily: 'MapoDPP, sans-serif'
            }}
          >
            {message}
          </div>
        )}
        
        {/* 확인 버튼 (이미지 버튼) */}
        <button
          onClick={onClose}
          style={{
            marginTop: '20px',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: 0,
            display: 'block'
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = 'scale(1.05)';
            e.currentTarget.style.transition = 'transform 0.2s ease';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
          }}
        >
          <img 
            src={hintOkBtnImage} 
            alt="확인"
            style={{
              maxWidth: '40dvw',
              height: 'auto',
              display: 'block'
            }}
          />
        </button>
      </div>
    </div>
  );
};

export default FirebaseErrorPopup;
